import { Card } from "@mui/material";
import React from "react";
import ReactCountryFlag from "react-country-flag";
import { findFlagUrlByIso2Code } from "country-flags-svg";
import { useSelector } from "react-redux";
import { v4 } from "uuid";
import { fetchCurrentState } from "../../../../redux/features/customerViewSlice";
import {
  dateRangeFormat,
  getCurrencySymbol,
  getImageUrlFromName,
  getNoteUrlFromName,
  guestInfo,
} from "../../../../util";
import { overviewModel } from "../../customerViewDataModel";
import OverviewCard from "./OverviewCard";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
// import currency from '../../../../assets/images/icons/currency.svg'
import duration from "../../../../assets/images/icons/duration.svg";
import group from "../../../../assets/images/icons/group.svg";
import destination from "../../../../assets/images/icons/destination.svg";
import currency from "../../../../assets/images/icons/currency.svg";
import { useEffect } from "react";

import {
  analyticsEvent,
  eventName,
} from "../../../common/Analytics/AnalyticsEvent";
import { useRef } from "react";
import { tr } from "date-fns/locale";
import { NumericFormat } from "react-number-format";
import ReactMoreReadLess from "../../../common/ReadMoreReadLess/ReactMoreReadLess";
import emojiFlags from "emoji-flags";

function OverviewTab(props) {
  const targetRef = useRef(null);

  console.log(">>>>>:: Overview Rendered");

  const tripStateData = props.tripStateData;
  // const tripStateData = useSelector(fetchCurrentState)
  const overviewDetails = overviewModel(tripStateData.trip_days);
  // console.log(overviewDetails)

  let country = `https://flagcdn.com/16x12/${tripStateData.address.country_code.toLowerCase()}.png`;
  let country_2x = `https://flagcdn.com/16x12/${tripStateData.address.country_code.toLowerCase()}.png 3x`;
  let country_3x = `https://flagcdn.com/16x12/${tripStateData.address.country_code.toLowerCase()}.png 3x`;

  return (
    <div>
      <Card
        variant="outlined"
        sx={{
          paddingLeft: "20px",
          paddingRight: "20px",
          paddingTop: "8px",
          paddingBottom: "17px",
          marginBottom: "24px",
          borderRadius: "0px",
          borderBottom: "none",
          BorderTop: "5px solid #F1F3F9",
          marginTop: "-1px",
        }}
      >
        <div className="trip-items">
          <p
            className="body3"
            style={{ marginTop: "16px", marginBottom: "16px" }}
          >
            <span style={{ color: "var(--gray100)", display: "flex" }}>
              <img className="icon-size" src={destination} alt="dest"></img>
              &nbsp;&nbsp;&nbsp;
              <span className="truncated" style={{ color: "var(--gray80)" }}>
                Destination :
                <span style={{ width: "100%" }}>
                  &nbsp;
                  {tripStateData.address.city
                    ? tripStateData.address.city
                    : tripStateData.address.country}
                  ,{" "}
                  {tripStateData.address.country
                    ? tripStateData.address.country
                    : tripStateData.address.continent}
                  &#160;&#160;
                </span>
              </span>
              <span>
                {/* <ReactCountryFlag
                  countryCode={tripStateData.address.country_code}
                  svg
                /> */}
                <img
                  src={country}
                  srcSet={country_2x + ", " + country_3x}
                  width="16"
                  height="12"
                ></img>
              </span>
            </span>
          </p>
          <p
            className="body3"
            style={{ marginTop: "16px", marginBottom: "16px" }}
          >
            <span style={{ color: "var(--gray100)", display: "flex" }}>
              <img className="icon-size" src={duration} alt="time"></img>
              &nbsp;&nbsp;&nbsp;
              <span style={{ color: "var(--gray80)" }}>Duration :</span>&nbsp;
              {tripStateData.properties.trip_summary.duration_days} Days &nbsp;
              {tripStateData.properties.trip_summary.start_date &&
                tripStateData.properties.trip_summary.end_date &&
                "(" +
                  dateRangeFormat(
                    tripStateData.properties.trip_summary.start_date,
                    tripStateData.properties.trip_summary.end_date
                  ) +
                  ")"}
            </span>
          </p>
          <p
            className="body3"
            style={{ marginTop: "16px", marginBottom: "16px" }}
          >
            <span style={{ color: "var(--gray100)", display: "flex" }}>
              <img className="icon-size" src={group} alt="people"></img>
              &nbsp;&nbsp;&nbsp;
              <span style={{ color: "var(--gray80)" }}>Group Size :</span>&nbsp;
              {guestInfo(
                tripStateData.properties.guest_info[0].no_of_adults,
                tripStateData.properties.guest_info[0].no_of_children
              )}
            </span>
          </p>
          {/* <p > */}
          <p
            className="body3"
            style={{
              color: "var(--gray100)",
              marginTop: "0px",
              marginBottom: "25px",
              display: "flex",
            }}
          >
            <img className="icon-size" src={currency} alt="currency"></img>
            &nbsp;&nbsp;&nbsp;
            <span style={{ color: "var(--gray80)" }}>Price (approx.) :</span>
            &nbsp;
            <span style={{ color: "#E09804", fontWeight: "600" }}>
              {getCurrencySymbol(tripStateData.properties.price[0].unit)}
              {/* {tripStateData.properties.price[0].value} */}
              <NumericFormat
                value={tripStateData.properties.price[0].value}
                thousandsGroupStyle="lakh"
                thousandSeparator=","
                displayType="text"
                renderText={(value) => <b>{value}</b>}
              />
              &nbsp;
            </span>
            <span style={{ color: "var(--gray60)" }}>
              ({tripStateData.properties.price[0].unit})
            </span>
          </p>

          {/* </p> */}
          <p className="body3">
            <Stack
              direction="row"
              sx={{ display: "flex", flexWrap: "wrap", marginLeft: "0px" }}
            >
              {tripStateData.properties.tags.map((tag) => {
                return (
                  <Chip
                    label={tag}
                    key={v4()}
                    style={{
                      background: "#F1F3F9",
                      color: "var(--gray80)",
                      marginRight: "8px",
                      marginBottom: "8px",
                      fontSize: "15px",
                    }}
                  />
                );
              })}
            </Stack>
            {/* {tripStateData.properties.tags
              .toString()
              .split(',')
              .join(', ')
              .toString()} */}
          </p>
          {/* <p
            className="body4"
            style={{ color: 'var(--gray80)', marginTop: '0px' }}
          >
            Trip price indicated above is estimated for 2 people’s stay and
            activities. Prices are likely to change based on trip dates and any
            changes to the itinerary.
          </p> */}
          {tripStateData.hasOwnProperty("notes") &&
            tripStateData.notes.map((notes) => {
              return (
                <div
                  className="notes-div"
                  style={{ marginTop: "17px", marginBottom: "10px" }}
                >
                  <div style={{ display: "inline-flex" }}>
                    <span>
                      <img
                        src={getImageUrlFromName(notes.icon_name)}
                        alt=""
                        className="notes-icon"
                        style={{
                          width: "20px",
                          height: "auto",
                          marginTop: "5px",
                        }}
                      ></img>
                    </span>
                    <p
                      className="body3 notes-para"
                      style={{ color: "var(--gray100)" }}
                    >
                      <ReactMoreReadLess
                        moreText={"Read more"}
                        lessText={"Read less"}
                        showArrow={true}
                        lines={"3"}
                        analytics={true}
                        analyticsProps={{
                          page: "Overview",
                          eventName: eventName.Overview_note_expanded,
                        }}
                      >
                        {/* {note.value} */}
                        {notes.value}
                      </ReactMoreReadLess>
                    </p>
                  </div>
                </div>
              );
            })}
        </div>
      </Card>
      {overviewDetails.map((overviewData) => {
        return <OverviewCard key={v4()} overviewData={overviewData} />;
      })}
    </div>
  );
}

export default OverviewTab;
export const MemoizedOverviewTab = React.memo(OverviewTab);
